const { VITE_CONVERSATIONS_API } = import.meta.env;

/**
 * Per-user preferences on the conversations service. The trailing slash matches
 * the backend route (`/api/conversations/v1/preferences/`) so the request hits
 * it directly instead of relying on a 307 slash redirect.
 */
export const userPreferencesPath = () => `${VITE_CONVERSATIONS_API}/preferences/`;

export interface UserPreferencesResponse {
  /** ISO timestamp of when the user accepted the MCP guidelines, or `null` if
   *  they never have. */
  mcp_guidelines_accepted_at: string | null;
  /** Whether agents may read and write this user's memories. The service
   *  resolves the never-chosen case to its default, so this is always a
   *  boolean. */
  memories_enabled: boolean;
}

/** Every field is optional: an omitted field leaves that preference untouched,
 *  so updating one never clobbers another. */
export interface UserPreferencesUpdate {
  accept_mcp_guidelines?: boolean;
  memories_enabled?: boolean;
}
